export type BadgeTone = "primary" | "accent" | "secondary";

export const badgeClasses: Record<BadgeTone, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export const dotClasses: Record<BadgeTone, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

export const filledChip: Record<BadgeTone, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-foreground-950",
};